
import React, { useState, useEffect, useContext } from 'react';
import { ListView, PullToRefresh } from 'antd-mobile';
import SearchWrapper from '@/components/searchWrapper'
import ListBox from '@/components/listBox';
import Filter from '@/components/filter'

import { list, info } from '@/services/saas/conference';
import { getIdByCode, getAttrsByTmpId, getAttrList} from '@/services/saas/appAttr';

import { MyContext } from '@/utils/contextManager';
import { useHistory, useParams } from 'react-router';
import sysConfig from '@/sysConfig';
const { preRouteUrl } = sysConfig;

const PageSize = 4;

const ListWrap = (props) => {
  return <ul className="conference-list">{props.children}</ul>;
}

const getDefaultData = async (appCode, typeCode) => {
  const respAttrTemp = await getIdByCode({
    // appCode: typeCode === '2' ? 'school-classroom' : 'mail-classroom',
    appCode,
    tableCode: 'ts_conference'
  });
  if (respAttrTemp.success) {
    const respAttrs = await getAttrsByTmpId({
      templateId: respAttrTemp.data
    });
    if (respAttrs.success) {
      const filterList = await getAttrs(respAttrs.data);
      return filterList;
    }
  }
}

const getAttrs = async (data) => {
  const filterList = {};
  for (let i = 0; i < data.length; i++) {
    let item = data[i];
    if (item.attr.dataType === 'list') {
      filterList[item.detailId] = {
        child: item.child.detailId,
        label: item.attributeDisplayname,
        list: []
      };
      if (!item.attr.pattributeId) {
        const resp = await getAttrList({
          attributeTemplateDetailId: item.detailId
        });
        if (resp && resp.success) {
          filterList[item.detailId].list = resp.data.map(item => ({
            name: item.text,
            value: item.value
          }));
        }
      }
    }
  }
  return filterList;
}


const ConferenceList = (props) => {

    const history = useHistory();

    const locationParam = useParams();

    const { config = {} } = props;

    const { conferenceStatus, conferenceType, replayable, deptId } = config;

    const defaultOptions = {
      size: PageSize,
      // orderName: replayable === '0' ? 'SCHEDULED_START_TIME' : '',
      // orderDesc: 'no',
      conferenceStatus,
      sceneCode: conferenceType,
      replayable,
      deptId
    }

    const source = new ListView.DataSource({
      getRowData: (dataBlob, sectionID, rowID) => {
        return dataBlob[sectionID][rowID];
      },
      rowHasChanged: (row1, row2) => row1 !== row2,
    });

    const [hasMore, setHasMore] = useState(true);

    const [pageIndex, setIndex] = useState(0);

    const [data, setData] = useState([]);

    const [attrData, setAttrData] = useState([]);

    const [loading, setLoading] = useState(false);

    const [draging, setDraging] = useState(false);

    const [dataSource, setDataSouce] = useState(source);

    const [name, setSearchName] = useState("");

    const [filter, setFilter] = useState({});

    const { setFilters } = useContext(MyContext);

    const getAttrData = async () => {
      const appCode = props.appCode || locationParam.appCode;
      const data = await getDefaultData(appCode, conferenceType);
      setAttrData({ ...data });
    }

    const handleAttrSelect = async ({ id, child, value }) => {
      if (child && value) {
        console.log(value);
        const response = await getAttrList({
          attributeTemplateDetailId: child,
          pAttrOptionValue: value
        });
        if (!response.success) {
          return ;
        }
        attrData[child].list = response.data.map(item => ({
          name: item.text,
          value: item.value
        }));
      }
      if (child && !value) {
        const clearChild = (item, key) => {
          const child = item[key].child;
          if (child) {
            item[child].list = [];
            clearChild(item, child);
          }
        }
        clearChild(attrData, id);
      }
      setAttrData({
        ...attrData
      })
    }

    const getData = async (page) => {
      setLoading(true);
      if (!page) {
          page = 1;
      }
      const { startTime: scheduledStartTimeBeginDate, endTime: scheduledStartTimeEndDate, ...other } = filter;

      const param = {
        ...defaultOptions,
        ...other,
        scheduledStartTimeBeginDate,
        scheduledStartTimeEndDate,
        name,
        current: page,
      };
      if (defaultOptions.replayable !== '1') {
        param.autoPlatlive = '1';
      };
      const resp = await list(param);
      if (!resp.success) {
        return ;
      }
      let datas = [];
      if (page !== 1) {
        datas = [...data];
      }
      datas = [
        ...datas,
        ...resp.data.records.map(item => {
          const [ gradeType, grade, subejct ] = item.conferenceAttributeDetailList;
          return ({
            id: item.id,
            coverUrl:item.coverUrl,
            time: item.scheduledStartTime,
            status: item.conferenceStatus,
            title: item.name,
            schoolName: item.deptName,
            teacherName: item.memberName,
            gradeName: grade && grade.attributeValueName,
            subjectName: subejct && subejct.attributeValueName,
            gradeType,
            // personNumber: '1111'
          })
        })
      ]

      setLoading(false);
      setDraging(false);
      setData(datas);
      setDataSouce(dataSource.cloneWithRows(datas));
      setHasMore(resp.data.current < resp.data.pages);
      setIndex(page);
    }

    const onEndReached = () => {
      if (!loading && hasMore) {
        getData(pageIndex + 1);
      }
    };

    const rowClick = async (id) => {
      const resp = await info({ id });
      if (!resp.success) {
        return ;
      }
      const { conferenceStatus } = resp.data;
      switch (conferenceStatus) {
        case '1':
          history.push(`${preRouteUrl}/livePlay/conference/${id}`);
          break;
        case '2':
          history.push(`${preRouteUrl}/livePlayback/conference/${id}`);
          break;
        default:
          break;
      }
    }



    useEffect(() => {
        getData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filter, name]);

    useEffect(() => {
      setFilters(
        <Filter
          // multiple
          data={attrData}
          onSelect={handleAttrSelect}
          key={attrData.length === 0 && new Date().getTime()}
          handleSearch={(item) => {
            const attrQuery = JSON.stringify(Object.keys(item).filter(key => Object.keys(attrData).indexOf(key) > -1).map(id => (
              {
                templateDetailId:id,
                attributeValue: item[id][0]
              }
            )));
            const startTime = item.startTime;
            const endTime = item.endTime;
            setFilter({
              attrQuery,
              startTime,
              endTime
            });
          }}
        >
        </Filter>
      );
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [attrData]);

    useEffect(() => {
      if (conferenceType !== '3') {
        getAttrData();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const row = (rowData, sectionID, rowID) => {
      const { id, time, status, title, schoolName, teacherName, gradeName, subjectName, personNumber, coverUrl } = rowData;
      return (
        <ListBox
          id={id}
          time={time}
          status={status}
          title={title}
          schoolName={schoolName}
          teacherName={teacherName}
          gradeName={gradeName}
          subjectName={subjectName}
          personNumber={personNumber}
          coverUrl={coverUrl}
          onClick={rowClick}
      ></ListBox>
      )
    }
    return (
        <ListView
        dataSource={dataSource}
        renderHeader={() => (<SearchWrapper onChange={setSearchName}></SearchWrapper>)}
        renderFooter={() => (
          <div style={{ padding: 30, textAlign: 'center' }}>
            {hasMore ? (loading ? '加载中...' : '加载完成') : '没有更多'}
          </div>
        )}
        renderBodyComponent={() => <ListWrap />}
        renderRow={row}
        className="conference-list-wrap"
        pageSize={PageSize}
        scrollRenderAheadDistance={500}
        onEndReached={onEndReached}
        onEndReachedThreshold={10}
        pullToRefresh={
          <PullToRefresh
            refreshing={draging}
            onRefresh={() => {
              setDraging(true);
              getData();
            }
          }
        />
        }
      />
    )
}

export default ConferenceList;
